import { useTranslation } from 'react-i18next'
import { Alert } from '@/components/ui'
import type { SettingsSaveError } from '@/lib/settingsSaveError'

export interface SettingsSaveAlertProps {
  error: SettingsSaveError
  className?: string
}

/**
 * PAY-1 (T149-082/083/084): the persistent inline "not saved" alert shown
 * above a settings form after a save did not happen, either a client
 * validation stop (`error.fieldCount`) or a server failure
 * (`error.serverMessage`). One component, reused by every settings tab with
 * a save handler, so the copy can't drift between them.
 */
export function SettingsSaveAlert({ error, className }: SettingsSaveAlertProps) {
  const { t } = useTranslation('settings')

  return (
    <Alert variant="error" className={className} data-testid="settings-save-error">
      {error.fieldCount ? t('messages.not_saved_field_count', { count: error.fieldCount }) : t('messages.not_saved')}
      {error.serverMessage ? ` ${error.serverMessage}` : null}
    </Alert>
  )
}
